import CompanyMapContainer from './CompanyMapContainer';
import CompanyLocationCol from './CompanyLocationColumns';
import { Row } from 'react-bootstrap';

const geoJSON = (data) => {
    const { locations, contact } = data;

    const features = {
        type: "FeatureCollection",
        features: locations
            .filter((loc) => loc.geometry && loc.geometry.coordinates)
            .map((loc, index) => (
                {
                    type: "Feature",
                    geometry: loc.geometry,
                    //bbox: loc.features[0].bbox,
                    properties: {
                        id: `59c0c8e322f3375db4d8912${index}`,
                        index: index,
                        isActive: loc.headquarters,
                        //logo: "http://placehold.it/32x32",
                        //image: "photo-1426122402199-be02db90eb90.jpg",
                        link: "#",
                        url: "#",
                        name: `${loc.location_city}, ${loc.location_country?.label}`,
                        //subtitle: "Entire apartment",
                        email: contact.contact_email,
                        employee: loc.location_size?.label,
                        //person: "John",
                        //avatar: "img/avatar/avatar-7.jpg",
                        phone: loc.location_phone,
                        address: `${loc.location_street}, ${loc.location_city}, ${loc.location_country?.label}${loc.location_zip ? ', ' + loc.location_zip : ''}`,
                        about: `${loc.location_street}, ${loc.location_city}, ${loc.location_country?.label}`,
                        tags: ["magna", "culpa"]
                    }
                }
            ))

    }

    return features
}

const CompanyLocation = (data) => {
    const locations = data.data;
    const hasValidLocations = locations.locations.filter((loc) => loc.geometry && loc.geometry.coordinates).length > 0;

    return (
        <div id="location" className="text-block">
            <h2 className="mb-4 h4">Location</h2>

            {/* Interactive Map Section */}
            {hasValidLocations ? (
                <CompanyMapContainer 
                    locations={locations.locations.filter(loc => loc.geometry && loc.geometry.coordinates)}
                    contact={locations.contact}
                />
            ) : (
                <Row>
                    {locations.locations.map((item, index) => (
                        <CompanyLocationCol key={index} location={item} />
                    ))}
                </Row>
            )}
        </div>
    )
}

export default CompanyLocation;